import { v4 as uuidV4 } from 'uuid';

export const generateId = () => uuidV4();
